module.exports = __webpack_public_path__ + "b03f2ec28f8e60e61974dd8c57610e5b.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Bold.woff
// module id = 351
// module chunks = 0